/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUntrackedTipsRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetUntrackedTipsResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getUntrackedTips = (request: GetUntrackedTipsRequest, options?: CashRequestOptions) => post<GetUntrackedTipsRequest, GetUntrackedTipsResponse>("/proxy/services/squareup.timecards.TimeCalculationReportService/GetUntrackedTips", request, {...options, rejectOnError: true })